angular.module('app').directive('apSelectFile',
    ['aprgettext', 'MimeTypeRepository', 'PatientSettingsService',
        function (gettext, MimeTypeRepository, PatientSettingsService) {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: '/app/views/directives/apSelectFile.html',
                scope: {
                    // Use '@' for one way binding.  String value is returned.
                    // Use '=' for two way binding.  An object is returned.
                    // Use '&' for a method.
                    maxSizeKb: '=maxSizeKb',
                    fileType: '=fileType',
                    selectedFileName: '=selectedFileName',
                    selectedFileContents: '=selectedFileContents',
                    selectedMimeType: '=selectedMimeType',
                    validationMessage: '=validationMessage',
                    practiceForm:'=practiceForm',
                    sending: '=sending'
                },

                controller: function($scope) {
                    //var myInputElement = angular.element(element.find('#inputFile'));

                    var featureList = PatientSettingsService.getPatientFeatures();
                    var messageAttachmentConfig = featureList.PatientMessageAttachment;

                    $scope.selectFileModel = {
                        maxSizeKb: 0,
                        mimeTypes: { Types: [] },
                        allowableFileExtensions: ''
                    };

                    $scope.isSelectedFileMimeType = function isSelectedFileMimeType(selectedFile) {
                        var isValid = false;

                        _.forEach($scope.selectFileModel.mimeTypes, function(type) {
                            if (type.MimeType.toUpperCase() === selectedFile.type.toUpperCase()) {
                                isValid = true;
                                return false; //break the loop
                            }
                        });

                        if (!isValid) {
                            $scope.validationMessage = gettext('An invalid file was selected.  Only') + ' ' + $scope.selectFileModel.allowableFileExtensions + ' ' + gettext('files can be selected.');
                        }

                        return isValid;
                    };


                    $scope.isSelectedFileSizeValid = function isSelectedFileSizeValid(selectedFile) {
                        var isValid = true;

                        if (selectedFile.size > ($scope.selectFileModel.maxSizeKb * 1024)) {
                            $scope.validationMessage = gettext('The selected file exceeds the maximum allowable size.  Please select another file.') + ' (' + $scope.selectFileModel.maxSizeKb + ' KB)';
                            isValid = false;
                        }

                        return isValid;
                    };

                    $scope.isSelectedFileExtensionValid = function isSelectedFileExtensionValid(selectedFile) {
                        var isValid = false;
                        var extension = selectedFile.name.toUpperCase().split('.');
                        extension = '.' + extension[1];
                        _.forEach($scope.selectFileModel.mimeTypes, function(type) {
                            if (extension === type.FileExtension.toUpperCase()){
                                isValid = true;
                                return false; //break the loop
                            }
                        });

                        return isValid;
                    };




                    $scope.inputFileOnchangeCallback = function inputFileOnchangeCallback(myEventArg) {
                        $scope.validationMessage = '';
                        $scope.selectedFileName = '';
                        $scope.selectedFileContents = '';
                        $scope.selectedMimeType = '';

                        if (!myEventArg || !myEventArg.target) {
                            $scope.validationMessage = gettext('Input element is not defined.');
                            return;
                        }

                        var files = myEventArg.target.files;
                        if (!files || files.length <= 0) {
                            // User pressed the cancel button
                            return;
                        }

                        var selectedFile = files[0];
                        var myInputFileElement = myEventArg.target;

                        if (!$scope.isSelectedFileExtensionValid(selectedFile)) {
                            if (myInputFileElement) {
                                myInputFileElement.value = null;
                            }
                            
                            // IE11 FIX: Note, this line was moved here: it once resided in isSelectedFileExtensionValid, but IE11 would skip over the error message.
                            $scope.validationMessage = gettext('An invalid file was selected.  Only') + ' ' + $scope.selectFileModel.allowableFileExtensions + ' ' + gettext('files can be selected.');

                            $scope.$apply();
                            return;
                        }

                        if (!$scope.isSelectedFileMimeType(selectedFile)) {
                            if (myInputFileElement) {
                                myInputFileElement.value = null;
                            }
                            $scope.$apply();
                            return;
                        }

                        if (!$scope.isSelectedFileSizeValid(selectedFile)) {
                            if (myInputFileElement) {
                                myInputFileElement.value = null;
                            }

                            // IE11 FIX: Note, this line was moved here: it once resided in isSelectedFileSizeValid, but IE11 would skip over the error message.
                            $scope.validationMessage = gettext('The selected file exceeds the maximum allowable size.  Please select another file.') + ' (' + $scope.selectFileModel.maxSizeKb + ' KB)';

                            $scope.$apply();
                            return;
                        }



                        $scope.selectedFileName = selectedFile.name;
                        $scope.selectedMimeType = selectedFile.type;
                        $scope.selectedFileContents = '';


                        var reader = new FileReader();
                        reader.onload = function (e) {
                            if (e != null) {
                                $scope.selectedFileContents = e.target.result;
                                $scope.$apply();
                            }
                        };

                        reader.readAsDataURL(selectedFile);

                        $scope.$apply();



                    };


                    function loadMaxFileSize() {
                        if ($scope.maxSizeKb && !isNaN($scope.maxSizeKb) && $scope.maxSizeKb <= messageAttachmentConfig.FileAttachmentConfig.MaxFileSizeKb) {
                            $scope.selectFileModel.maxSizeKb = $scope.maxSizeKb;
                        }
                        else {
                            $scope.selectFileModel.maxSizeKb = messageAttachmentConfig.FileAttachmentConfig.MaxFileSizeKb;
                        }
                    }


                    function loadAllowableFileTypes() {
                        if ($scope.fileType) {
                            $scope.selectFileModel.allowableFileExtensions = $scope.fileType;
                        }
                        else {
                            $scope.selectFileModel.allowableFileExtensions = messageAttachmentConfig.FileAttachmentConfig.AllowableFileExtensions;
                        }

                        if ($scope.selectFileModel.allowableFileExtensions) {
                            var extensions = $scope.selectFileModel.allowableFileExtensions.split(',');

                            _.forEach(extensions, function (ext) {
                                $scope.selectFileModel.mimeTypes.Types.push(
                                    {
                                        FileExtension: ext.trim(),
                                        MimeType: ''
                                    });
                            });

                            MimeTypeRepository.getMimeTypeFromFileExtension($scope.selectFileModel.mimeTypes)
                                .then(function (data) {
                                    $scope.selectFileModel.mimeTypes = data;
                                })
                                .catch(function () {
                                    $scope.validationMessage = gettext('Was not able to retrieve MIME type mappings.');
                                })
                                .finally(function () {
                                    $scope.loading = false;
                                });
                        }
                        else {
                            $scope.validationMessage = gettext('No file type criteria was supplied.');
                        }
                    }




                    function loadView() {
                        $scope.loading = true;
                        loadMaxFileSize();
                        loadAllowableFileTypes();
                    }
                    loadView();
                }
            };
        }
    ]
);